window.BundleConfig = {
  sectionTitle: 'Kaufe jetzt',
  addToCartText: 'In den Warenkorb legen',
  recommendedLabel: 'Am beliebtsten',
  options: [
    {
      id: 'single',
      label: '1 Packung',
      variantIndex: 0,
      quantity: 1,
      price: '4,39 €',
      originalPrice: null,
      badge: null,
      note: '+ Versand 5-7 €',
      recommended: false,
    },
    {
      id: 'biweekly',
      label: '2-Wochenvorrat - 14 Packungen',
      variantIndex: 0,
      quantity: 14,
      price: '52,68 €',
      originalPrice: '61,46 €',
      badge: '12 + 2 gratis',
      note: '+ kostenloser Versand',
      recommended: true,
    },
    {
      id: 'monthly',
      label: 'Monatsvorrat - 30 Packungen',
      variantIndex: 0,
      quantity: 30,
      price: '105,36 €',
      originalPrice: '131,70 €',
      badge: '24 + 6 gratis',
      note: '+ kostenloser Versand',
      recommended: false,
    },
  ],
};
